import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/messaging'

export const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyBxJ3S_TWeXam868GCBtvxohGjtaQ4JkII',
  authDomain: 'dev-2026-core-project.firebaseapp.com',
  databaseURL: 'https://dev-2026-core-project-default-rtdb.firebaseio.com',
  projectId: 'dev-2026-core-project',
  storageBucket: 'dev-2026-core-project.firebasestorage.app',
  messagingSenderId: '596919312610',
  appId: '1:596919312610:web:daef4571fd27792af97ebb',
})
export const firestore = firebaseApp.firestore()

const { Timestamp } = firebase.firestore
export { Timestamp }

// WebPush
export const webPushKey =
  'BGY3H9tFeNW95EqVHjZQxH09G-9FPixRgCp5rRRiG_F6DFqjZzO2ibZOow9xKpNj7q-6tk2HojlXebqrDUCE5H4'

export async function getWebPushToken() {
  const messaging = firebaseApp.messaging()
  const retries = 3
  for (let i = 0; i < retries; i++) {
    try {
      const token = await messaging.getToken({ vapidKey: webPushKey })
      console.log('Web push token acquired successfully.')
      return token
    } catch (err) {
      console.log(
        `Retrying in a few secconds, Attempt ${i + 1}/${retries} failed:`,
        err
      )
      if (i < retries) {
        await new Promise((resolve) => setTimeout(resolve, 5000))
      } else {
        throw err
      }
    }
  }
  throw new Error('Failed to acquire web push token.')
}

export async function delWebPushToken() {
  const messaging = firebaseApp.messaging()
  try {
    await messaging.deleteToken()
  } catch (err) {
    console.log(err)
    return false
  }
  return true
}

export default async () => {
  if ('serviceWorker' in navigator) {
    try {
      // サービスワーカーを手動で登録
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js'
      )
      console.log('Service Worker registered with scope:', registration.scope)

      await navigator.serviceWorker.ready
      console.log('Service Worker is active.')
    } catch (error) {
      console.error(
        'Service Worker registration or token retrieval failed:',
        error
      )
    }
  } else {
    console.error('Service Workers are not supported in this browser.')
  }
}
